export interface HttpCost {
  totalCost: number;
  local: number;
  redirect?: number;
  httpCache?: number;
  dns: number;
  tcp: number;
  tls: number;
  request: number;
  response: number;
}
export function getHttpCost(url: string) {
  let result: HttpCost = {
    totalCost: 0,
    local: 0, // local 包括 redirect 和 httpCache
    redirect: 0,
    httpCache: 0,
    dns: 0,
    tcp: 0,
    tls: 0,
    request: 0,
    response: 0
  };
  try {
    const resources = performance.getEntriesByType('resource').reverse() as PerformanceSourceEntry[];
    for (const item of resources) {
      if (item.name === url) {
        const totalCost = Math.round(item.duration);
        const beforeDNS = Math.max(Math.round(item.domainLookupStart - item.startTime), 0);
        // @ts-ignore
        const redirect = item.redirectStart > 0 ? Math.max(Math.round(item.redirectEnd - item.redirectStart), 0) : 0;
        // @ts-ignore
        const httpCache = item.fetchStart > 0 ? Math.max(Math.round(item.domainLookupStart - item.fetchStart), 0) : 0;
        const dns = Math.round(item.domainLookupEnd - item.domainLookupStart);
        const tls = Math.round(item.requestStart - item.secureConnectionStart);
        const tcp = Math.round(item.secureConnectionStart - item.connectStart);
        const request = Math.round(item.responseStart - item.requestStart);
        const response = Math.round(item.responseEnd - (item.responseStart || item.startTime));

        result = { ...result, totalCost, local: beforeDNS, redirect, httpCache, dns, tcp, tls, request, response };
        break;
      }
    }
  } catch (error) {

  }
  return result;
}
